export default 'Enter a valid hexadecimal value.';